var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{attrs:{"id":"app"}},[_c('TopNavbar'),_c('div',{staticClass:"d-flex mx-0 flex-grow-1"},[_c('SideBar',{on:{"setTab":_vm.setActiveTab}}),_c('SideBarPanel',{attrs:{"activetab":_vm.activeTab}}),_c('CenterArea'),(_vm.isLayersVisible)?_c('Layers'):_vm._e(),_c('SlidesPanel')],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }